import { client } from "./client";
import type { SanityProduct } from "./types";

const PRODUCT_FIELDS = `
  _id, name, subtitle, description, amazonLink, orderRank,
  productIdentifiers {
    ndc,
    upc
  },
  imageUrl, images, category, price, perUnit,
  ratingAvg, ratingCount, features,
  activeIngredients, inactiveIngredients,
  directions, warnings, storage
`;

export async function getAllProducts(): Promise<SanityProduct[]> {
  return client.fetch(`*[_type == "product"] | order(orderRank) { ${PRODUCT_FIELDS} }`);
}

export async function getProductById(id: string): Promise<SanityProduct | null> {
  return client.fetch(
    `*[_type == "product" && _id == $id][0] { ${PRODUCT_FIELDS} }`,
    { id },
  );
}
